import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/logo/icho_bg.png';
import _imports_1 from '@/assets/home_suyuan.png';
import _imports_2 from '@/assets/home_xietong.png';
import _imports_3 from '@/assets/home-block-4.png';
import _imports_4 from '@/assets/home_bihuan.png';
const _hoisted_1 = {
  class: "home fs-s"
};
const _hoisted_2 = {
  class: "block1"
};
const _hoisted_3 = {
  class: "text-box text-white fs-xl fw-b d-flex jc-between ai-center"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "icho_box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title_subtitle"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "WELL碳手印"), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, "以碳携手·造福于人")]), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1);
const _hoisted_6 = {
  style: {
    "height": "100vh"
  }
};
const _hoisted_7 = {
  class: "block1"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-box text-white fs-xl fw-b d-flex jc-between ai-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "wow fadeInLeft left_text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title_2"
}, "什么是碳手印？"), /*#__PURE__*/_createElementVNode("span", null, "反映组织、活动、机制及产品运营对环境形成正面影响的量化技术")])], -1);
const _hoisted_9 = {
  class: "block1"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-box text-white fs-xl fw-b d-flex jc-between ai-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "wow fadeInLeft left_text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title_2"
}, "碳手印活动宗旨"), /*#__PURE__*/_createElementVNode("div", null, "通过数智化技术量化组织、活动、机制及个人对环境的正面影响，旨在验证和推动相关标准的建设与应用")])], -1);
const _hoisted_11 = {
  class: "block block2"
};
const _hoisted_12 = {
  class: "text-box text-blue fs-l",
  "data-wow-delay": "0.5s"
};
const _hoisted_13 = {
  class: "logo-box"
};
const _hoisted_14 = ["onMouseenter", "onMouseleave"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  class: "block block3"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "title text-white fs-l"
}, "能者云集 群英荟萃", -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "gap-line"
}, null, -1);
const _hoisted_20 = {
  class: "carbon-active-list d-flex jc-between"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "img_box"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "title_box"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "img_box_title"
}, "WELL碳手印", -1);
const _hoisted_26 = {
  class: "img_box_subtitle"
};
const _hoisted_27 = {
  class: "item-bottom bg-white"
};
const _hoisted_28 = {
  class: "text-gray fs-xs pt-10"
};
const _hoisted_29 = {
  class: "to_btn text-orange d-flex ai-center"
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "前往", -1);
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "title text-white fs-l pt-80"
}, "集合众智 共襄盛举", -1);
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "gap-line"
}, null, -1);
const _hoisted_33 = {
  class: "carbon-active-list d-flex jc-between text-white"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "img_box2"
};
const _hoisted_36 = ["src"];
const _hoisted_37 = {
  class: "title_box"
};
const _hoisted_38 = {
  class: "img_box_title"
};
const _hoisted_39 = {
  class: "img_box_subtitle"
};
const _hoisted_40 = {
  class: "item-bottom text-center"
};
const _hoisted_41 = {
  class: "pt-20"
};
const _hoisted_42 = {
  class: "fs-xs pt-10"
};
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"block\"><div class=\"main-width block_juzhen\"><div class=\"\"><div><div class=\"title fs-xl fw-b\">碳手印价值矩阵</div><div class=\"subtitle pt-10 pb-40 fs-m text-gray\">了解碳手印与碳足迹的区别与联系</div></div><div style=\"text-align:center;\"><img src=\"" + _imports_1 + "\" width=\"700px\"></div></div></div></div><div class=\"block block_xietong\"><div class=\"main-width block_xietong_box\"><div class=\"title fs-xl fw-b\">碳手印活动双向协同</div><div class=\"pt-10 pb-40 fs-m text-gray\">碳手印文化与价值体系同步发展、相得益彰</div><img src=\"" + _imports_2 + "\"></div></div>", 2);
const _hoisted_45 = {
  class: "block block4 bg-bggray"
};
const _hoisted_46 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_47 = {
  class: "flex-1"
};
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-xl fw-b pb-10",
  style: {
    "color": "#61cdfc"
  }
}, "厚积薄发、持续创新", -1);
const _hoisted_49 = {
  class: "subtitle fs-m text-white pb-40"
};
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"s_list pb-20\"><div class=\"list_item\">《园区数智控碳体系创建与评价技术规范》</div><div class=\"list_item\">《基于量值溯源算法的精准碳计量技术导则》</div><div class=\"list_item\">《零碳智慧园区创建指南》</div><div class=\"list_item\">《碳手印情景减排量核算方法学》</div><div class=\"list_item\">《低碳健康企业ESG指标体系》</div></div>", 1);
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  width: "500"
}, null, -1);
const _hoisted_52 = {
  class: "block block_bihuan bg-bggray"
};
const _hoisted_53 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-xl fw-b"
}, "碳手印管理数据闭环", -1);
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle pt-10 pb-40 fs-m text-gray"
}, "基于人机环混合智能技术的数据开发流程及相关规范标准", -1);
const _hoisted_56 = {
  class: "d-flex ai-center"
};
const _hoisted_57 = {
  class: "pl-5 fs-m fw-b item_content"
};
const _hoisted_58 = {
  class: "pl-5 fs-x item_des"
};
const _hoisted_59 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "350"
}, null, -1);
import { ref, onMounted, nextTick, reactive } from 'vue';
import { WOW } from 'wowjs';
import Video from '../components/Video.vue';
import { useRouter } from 'vue-router';
import { Select, Right } from '@element-plus/icons-vue';
import { useStore } from 'vuex';
import { ProgressiveImage } from "vue-progressive-image";
export default {
  __name: 'Home',
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const imgs = [{
      src: require('@/assets/home_bg0.png'),
      preview: require('@/assets/home_bg0_pre.png')
    }];
    const textData = {
      block1: 'WELL碳手印<br>标志着<br>您对可持续未来的承诺和贡献',
      block2: '从初创公司到财富500强，都会使用WELL碳手印标准来提升其数字化、智能化水平，最大化资产价值，并优化其业务绩效。',
      block4: '基于60+国内外专家、10+年潜心研究的创新知识成果',
      block5_1: 'WELL碳手印标准将人文力量注入到团队活动',
      block5_2: '查看各个组织的ESG报告，使用WELL碳手印活动标准<br>可多方位提升企业的ESG表现。',
      block6_1: '加入我们的话题，<br>理解碳手印',
      block6_2: '我们在这里支持您的碳手印之旅。深入了解<br>我们的资源，包括随时可以观看的文章和视<br>频，以帮助您实现目标。'
    };
    if (store.state.VUEX_ISMOBILE) textData.block1 = 'WELL碳手印<br>标志着<br>您对可持续未来的<br>承诺和贡献';
    const logoList = reactive([{
      url: require('@/assets/logo/zgjzkxyjy.png'),
      name: '中国建筑科学研究院',
      flag: false
    }, {
      url: require('@/assets/logo/qhdx.png'),
      name: '清华大学中国新型城镇化研究院',
      flag: false
    }, {
      url: require('@/assets/logo/gjdw.jpg'),
      name: '国家电网节能服务有限公司',
      flag: false
    }, {
      url: require('@/assets/logo/mi.png'),
      name: '小米科技有限公司',
      flag: false
    }, {
      url: require('@/assets/logo/lvmi.png'),
      name: '深圳绿米联创科技有限公司',
      flag: false
    }, {
      url: require('@/assets/logo/ksyun.jpg'),
      name: '北京金山云网络技术有限公司',
      flag: false
    }, {
      url: require('@/assets/logo/delos-logo.png'),
      name: '得乐室中国（香港）有限公司<br>DELOS CHINA(HK) LIMITED',
      flag: false
    }, {
      url: require('@/assets/logo/jtl.jpg'),
      name: '苏州金螳螂建筑装饰股份有限公司',
      flag: false
    }]);
    // 聚合各行业专家学者，分享最新碳手印观点和技术成果。
    const carbonActive = [{
      title: '碳手印最佳实践项目评级',
      subtitle: '最佳实践项目评级',
      content: '选拔并展示优秀案例，通过交流促进碳手印技术提升。',
      path: '/project-active',
      src: require('@/assets/logo/well_project_bg.png')
    }, {
      title: '碳手印倡议·论坛·投资',
      subtitle: '倡议·论坛·投资',
      content: '与我们一起，用实际行动带动更多人参与碳手印活动。',
      path: '/initiative',
      src: require('@/assets/logo/well_jiaoliu_bg.png')
    }, {
      title: '碳手印辅导·选拔·展示',
      subtitle: '辅导·选拔·展示',
      content: '通过全过程咨询辅导服务，激发碳手印价值创造力。',
      path: '/video-base',
      src: require('@/assets/logo/well_fudao_bg.png')
    }];
    const loopList = [{
      content: '精细化计量',
      color: '#5b9bd5',
      des: '基于监测计量控制一体化技术'
    }, {
      content: '在线化监测',
      color: '#ed7d31',
      des: '基于无源无线型物联网标准'
    }, {
      content: '自动化管控',
      color: '#a5a5a5',
      des: '基于人机环混合智能技术'
    }, {
      content: '智能化调节',
      color: '#f9680d',
      des: '基于斡件服务标准'
    }, {
      content: '资产化开发',
      color: '#4472c4',
      des: '基于碳减排量核算方法学'
    }, {
      content: '自主化平衡',
      color: '#70ad47',
      des: '基于科学碳目标体系'
    }];
    const netActive = [{
      title: '碳友团',
      subtitle: '碳友团',
      content: '与碳手印爱好者们一起学习和创造，相关享受精彩纷呈的碳手印之旅',
      path: '/carbon-friend',
      src: require('@/assets/logo/well_friend_bg.png')
    }, {
      title: '会员计划',
      subtitle: '会员计划',
      content: '获得更为深入的碳手印服务，享受更多折扣、品牌支持和社交机会',
      path: '/member',
      src: require('@/assets/logo/well_member_bg.png')
    }, {
      title: '成为赋能官',
      subtitle: '碳手印赋能官',
      content: '运用资金、政策、标准和工具等资源赋能碳手印项目及参与者',
      path: '/export',
      src: require('@/assets/logo/well_eo_bg.png')
    }];
    const videoList = [{
      title: '什么是碳手印？',
      src: 'https://res.carbonhp.com/assetbundles/carbon/ch1.mp4'
    }, {
      title: '"碳路寻宝"九类零碳智慧之应时顺势',
      src: 'https://res.carbonhp.com/assetbundles/carbon/9lintan1.mp4'
    }, {
      title: '碳海淘金36计-缘起篇',
      src: 'https://res.enrider.com/miniVideo/36ji/normal/36ji-1.mp4'
    }];
    const esgList = ['2019年报告', '2021年报告', '2022年报告', '2020年报告', '2021年报告', '2021年报告', '2021年报告', '2022年报告'];
    const toPage = function (path) {
      router.push({
        path: path
      });
    };
    onMounted(() => {
      new WOW({
        live: false,
        offset: 0
      }).init();
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        height: "100vh",
        "pause-on-hover": false,
        interval: "10000"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            class: "wow fadeInLeft left_text",
            innerHTML: textData.block1
          }, null, 8, _hoisted_4), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ProgressiveImage), {
            "placeholder-src": require('@/assets/home_bg0_pre.png'),
            src: require('@/assets/home_bg0.png'),
            "object-cover": "",
            "custom-class": "bg-el-img"
          }, null, 8, ["placeholder-src", "src"])])])]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_image, {
            class: "bg-el-img",
            src: require('@/assets/home_bg1.png'),
            fit: "cover"
          }, null, 8, ["src"])])]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_image, {
            class: "bg-el-img",
            src: require('@/assets/home_bg2.png'),
            fit: "cover"
          }, null, 8, ["src"])])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(textData.block2), 1), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logoList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "logo_item",
          key: idx,
          onMouseenter: $event => item.flag = true,
          onMouseleave: $event => item.flag = false
        }, [_createElementVNode("div", {
          class: _normalizeClass(["logo_img", {
            'logo_ani_down': item.flag,
            'logo_ani_up': !item.flag
          }])
        }, [_createElementVNode("img", {
          src: item.url
        }, null, 8, _hoisted_15)], 2), _createElementVNode("div", {
          class: _normalizeClass(["logo_name fs-xs", {
            'logo_ani_down': !item.flag,
            'logo_ani_up': item.flag
          }]),
          innerHTML: item.name
        }, null, 10, _hoisted_16)], 40, _hoisted_14);
      }), 128))])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(carbonActive, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item list-item-bg list-item0",
          key: idx,
          onClick: $event => toPage(item.path)
        }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
          src: item.src
        }, null, 8, _hoisted_23), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString(item.subtitle), 1)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(item.content), 1)]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Right))]),
          _: 1
        })])], 8, _hoisted_21);
      }), 64))]), _hoisted_31, _hoisted_32, _createElementVNode("div", _hoisted_33, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(netActive, (item, idx) => {
        return _createElementVNode("div", {
          class: "list-item list-item2",
          key: idx,
          onClick: $event => toPage(item.path)
        }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
          src: item.src
        }, null, 8, _hoisted_36), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(idx === 2 ? 'CEO' : 'ICHO'), 1), _createElementVNode("div", _hoisted_39, _toDisplayString(item.subtitle), 1)])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(item.content), 1)])], 8, _hoisted_34);
      }), 64))])]), _hoisted_43, _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("div", _hoisted_49, _toDisplayString(textData.block4), 1), _hoisted_50]), _hoisted_51])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", null, [_hoisted_54, _hoisted_55, _createElementVNode("div", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(loopList, (item, idx) => {
        return _createElementVNode("div", {
          class: "pb-10 d-flex ai-center",
          key: idx
        }, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_icon, {
          color: item.color,
          size: "20"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Select))]),
          _: 2
        }, 1032, ["color"]), _createElementVNode("div", _hoisted_57, _toDisplayString(item.content) + "：", 1)]), _createElementVNode("div", _hoisted_58, _toDisplayString(item.des), 1)]);
      }), 64))])]), _hoisted_59])])]);
    };
  }
};